import { useState, useEffect } from 'react';
import { Container, Spinner, Modal, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { Login } from './Login';
import { UserStatus } from '../utils/jwtUtils';

export const AuthGuard = ({ children }) => {
    const { user, loading, getClaims } = useAuth();
    const [showStatusModal, setShowStatusModal] = useState(false);

    // Check user status when user is authenticated
    useEffect(() => {
        const checkUserStatus = async () => {
            if (!user || loading) {
                return;
            }

            // Small delay to ensure token is ready
            await new Promise(resolve => setTimeout(resolve, 100));

            try {
                // Get claims to check user status (force refresh to get latest claims)
                const claims = await getClaims(true);
                console.log('User claims:', claims); // Debug log
                
                if (claims && typeof claims.status === 'number') {
                    console.log('User status:', claims.status, 'Active:', UserStatus.Active); // Debug log
                    // If status is not Active (1), show warning modal
                    if (claims.status !== UserStatus.Active) {
                        console.log('Showing status modal - user is not active'); // Debug log
                        setShowStatusModal(true);
                    }
                } else {
                    console.log('No status claim found or status is not a number'); // Debug log
                }
            } catch (error) {
                console.error('Error checking user status:', error);
            }
        };

        checkUserStatus();
    }, [user, loading, getClaims]);

    if (loading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                <Spinner animation="border" role="status" />
                <span className="ms-3">Inicializando autenticación...</span>
            </Container>
        );
    }

    if (!user) {
        return <Login />;
    }

    return (
        <>
            {children}
            
            {/* Status Warning Modal */}
            <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Usuario no activo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="warning" className="mb-0">
                        El usuario no está activo. Consulte a su administrador.
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setShowStatusModal(false)}>
                        Entendido
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

